// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3aVfR","container":"classes_container__PWUU7","text":"classes_text__2icjR","title":"classes_title__3ihkE","subtitle":"classes_subtitle__2NdZx"};